import styled from 'styled-components';

export const ProfileMainWrap = styled.div(
  props => `
    .aisWrap {
    background: #fff;
    min-height: 52vh;
    overflow: auto;
}

.container {
    width: 1200px;
    margin: 0px auto;
}

.aisMain{
    width: 1310px;
    margin: 0 auto;
}

// Ais Landing CSS
.makeFlex {
  display: flex;
}

.aisLandingWrpr{
    z-index: 1;
    position: relative;
    background: #F2F2F2;
    padding-top: 40px;
}

.aisLandingWrpr::after{
    content: "";
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 230px;
    top: 0px;
    left: 0px;
    background: linear-gradient(180deg, #282A47 0.38%, #554276 100%);
}

.leftWrap{
    width: 280px;
    
    display: flex;
    margin-right: 16px;
    flex-direction: column
}

.rightWrap{
    padding-bottom: 128px;
    width: 904px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}
@charset "utf-8";
@use 'src/styles/Theme';

/* -- GLOBAL RESET --*/
html,
body {
  padding: 0px;
  margin: 0px;
  background: Theme.$globalBgColor;
  color: Theme.$globalColor;
  font-size: 16px;
  font-weight: 400;
  font-family: Theme.$globalFontFamily;
}

html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

img {
  max-width: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

a {
  color: Theme.$blueText;
  text-decoration: none;
  cursor: pointer;
}

a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}

input,
input::placeholder,
textarea,
textarea::placeholder,
input, input::placeholder, textarea, textarea::placeholder {
  font-family: Theme.$globalFontFamily;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}

/* -- GLOBAL MOBILE RESET --*/
@media screen and (prefers-reduced-motion: no-preference) {
  html {
    scroll-behavior: smooth;
  }
}

/* -- BACKGROUND COLORS -- */
.whiteBg {
  background-color: Theme.$whiteBg;
}
.transBg {
  background-color: transparent;
}
.redBg {
  background-color: Theme.$redBg;
}
.darkGreenBg {
  background-color: Theme.$darkGreenBg;
}
.extraDarkGreenBg {
  background-color: Theme.$extraDarkGreenBg;
}
.yellowBg {
  background-color: Theme.$yellowBg;
}
.lightGreenBg {
  background-color: Theme.$lightGreenBg;
}
.emeraldBg {
  background-color: Theme.$emeraldText;
}
.lightYellowBg {
  background-color: Theme.$lightYellowBg;
}
.orangeBg {
  background-color: Theme.$orangeText;
}
.f7Bg {
  background-color: #f7f7f7;
}
.lightOrangeBg{
  background-color: #FFF4F2;
}
.turqoiseBg{
  background-color: Theme.$turqoiseBg;
}

.blackText{
  color: #000;
}

/* -- SHADOWS -- */
.boxShadow {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
}

/* -- BORDERS -- */
.borderRight1 {
  border-right: 1px #e7e7e7 solid;
}
.borderBottom1 {
  border-bottom: 1px #e7e7e7 solid;
}
.borderTop1{
  border-top: 1px #e7e7e7 solid;
}
.emeraldBorder {
  border: 0.5px Theme.$emeraldText solid;
}

.borderRad2 {
  border-radius: 2px;
}
.borderRad8{
  border-radius: 8px;
}

/* -- STYLE CLASSES --*/
.makeRelative {
  position: relative;
}
.makeAbsolute {
  position: absolute;
}
.transXCenter {
  transform: translateX(-50%);
}
.transXLeftOne {
  transform: translateX(-90%);
}
.transXLeftTwo {
  transform: translateX(-71%);
}
.transYCenter {
  transform: translateY(-50%);
}
.positionCenter {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.stickyBottom {
  position: sticky;
  z-index: 20;
  bottom: 0px;
  width: 100%;
}
.fixedBottom {
  position: fixed;
  z-index: 20;
  bottom: 0px;
  left: 0px;
  width: 100%;
}
.fixed {
  overflow: hidden;
}
.scrollY {
  overflow-y: scroll;
}
.disabled {
  pointer-events: none;
  color: #b5a6b1;
}
.discList {
  list-style-type: disc;
}
.truncate {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wsNoWrap {
  white-space: nowrap;
}
.lineThrough {
  text-decoration: line-through;
}
.capText {
  text-transform: uppercase;
}
.normalText {
  text-transform: initial;
}
.pushRight {
  margin-left: auto;
}
.pushLeft {
  margin-right: auto;
}
.pushTop {
  margin-bottom: auto;
}
.pushBottom {
  margin-top: auto;
}
.oneFifthWidth {
  width: 20%;
}
.qtrWidth {
  width: 25%;
}
.halfWidth {
  width: 50%;
}
.thirdWidth {
  width: 75%;
}
.fullWidth {
  width: 100%;
}
.fitWidth {
  width: fit-content;
}
.maxWidth {
  width: max-content;
}
.cursorPointer {
  cursor: pointer;
}
.noPointer {
  cursor: default;
}
i::before,
i::after {
  content: '';
  box-sizing: border-box;
}

/* -- BOX PADDING -- */
.boxPadding {
  padding: 16px;
}
/* -- MARGIN TOP -- */
.appendTop0 {
  margin-top: 0px;
}
.appendTop1 {
  margin-top: 1px;
}
.appendTop2 {
  margin-top: 2px;
}
.appendTop3 {
  margin-top: 3px;
}
.appendTop4 {
  margin-top: 4px;
}
.appendTop5 {
  margin-top: 5px;
}
.appendTop6 {
  margin-top: 6px;
}
.appendTop8 {
  margin-top: 8px;
}
.appendTop9 {
  margin-top: 9px;
}
.appendTop10 {
  margin-top: 10px;
}
.appendTop12 {
  margin-top: 12px;
}
.appendTop14 {
  margin-top: 14px;
}
.appendTop15 {
  margin-top: 15px;
}
.appendTop16 {
  margin-top: 16px;
}
.appendTop18 {
  margin-top: 18px;
}
.appendTop20 {
  margin-top: 20px;
}
.appendTop22 {
  margin-top: 22px;
}
.appendTop23 {
  margin-top: 23px;
}
.appendTop24 {
  margin-top: 24px;
}
.appendTop26 {
  margin-top: 26px;
}
.appendTop28 {
  margin-top: 28px;
}
.appendTop30 {
  margin-top: 30px;
}
.appendTop32 {
  margin-top: 32px;
}
.appendTop36 {
  margin-top: 36px;
}
.appendTop76 {
  margin-top: 76px;
}

/* -- MARGIN RIGHT --*/
.appendRight1 {
  margin-right: 1px;
}
.appendRight2 {
  margin-right: 2px;
}
.appendRight3 {
  margin-right: 3px;
}
.appendRight4 {
  margin-right: 4px;
}
.appendRight5 {
  margin-right: 5px;
}
.appendRight6 {
  margin-right: 6px;
}
.appendRight7 {
  margin-right: 7px;
}
.appendRight8 {
  margin-right: 8px;
}
.appendRight10 {
  margin-right: 10px;
}
.appendRight11 {
  margin-right: 11px;
}
.appendRight12 {
  margin-right: 12px;
}
.appendRight14 {
  margin-right: 14px;
}
.appendRight15 {
  margin-right: 15px;
}
.appendRight16 {
  margin-right: 16px;
}
.appendRight18 {
  margin-right: 18px;
}
.appendRight20 {
  margin-right: 20px;
}
.appendRight22 {
  margin-right: 22px;
}
.appendRight24 {
  margin-right: 24px;
}
.appendRight26 {
  margin-right: 26px;
}
.appendRight28 {
  margin-right: 28px;
}
.appendRight30 {
  margin-right: 30px;
}
.appendRight32 {
  margin-right: 32px;
}
.appendRight34 {
  margin-right: 34px;
}
.appendRight36 {
  margin-right: 36px;
}
.appendRight44 {
  margin-right: 44px;
}

/* -- MARGIN BOTTOM --*/
.appendBottom1 {
  margin-bottom: 1px;
}
.appendBottom2 {
  margin-bottom: 2px;
}
.appendBottom3 {
  margin-bottom: 3px;
}
.appendBottom4 {
  margin-bottom: 4px;
}
.appendBottom5 {
  margin-bottom: 5px;
}
.appendBottom6 {
  margin-bottom: 6px;
}
.appendBottom8 {
  margin-bottom: 8px;
}
.appendBottom10 {
  margin-bottom: 10px;
}
.appendBottom12 {
  margin-bottom: 12px;
}
.appendBottom14 {
  margin-bottom: 14px;
}
.appendBottom15 {
  margin-bottom: 15px;
}
.appendBottom16 {
  margin-bottom: 16px;
}
.appendBottom18 {
  margin-bottom: 18px;
}
.appendBottom20 {
  margin-bottom: 20px;
}
.appendBottom22 {
  margin-bottom: 22px;
}
.appendBottom24 {
  margin-bottom: 24px;
}
.appendBottom25 {
  margin-bottom: 25px;
}
.appendBottom26 {
  margin-bottom: 26px;
}
.appendBottom28 {
  margin-bottom: 28px;
}
.appendBottom30 {
  margin-bottom: 30px;
}
.appendBottom32 {
  margin-bottom: 32px;
}
.appendBottom36 {
  margin-bottom: 36px;
}
.appendBottom53 {
  margin-bottom: 53px;
}

/* -- MARGIN LEFT --*/
.appendLeft1 {
  margin-left: 1px;
}
.appendLeft2 {
  margin-left: 2px;
}
.appendLeft3 {
  margin-left: 3px;
}
.appendLeft4 {
  margin-left: 4px;
}
.appendLeft5 {
  margin-left: 5px;
}
.appendLeft6 {
  margin-left: 6px;
}
.appendLeft7 {
  margin-left: 7px;
}
.appendLeft8 {
  margin-left: 8px;
}
.appendLeft9 {
  margin-left: 9px;
}
.appendLeft10 {
  margin-left: 10px;
}
.appendLeft11 {
  margin-left: 11px;
}
.appendLeft12 {
  margin-left: 12px;
}
.appendLeft14 {
  margin-left: 14px;
}
.appendLeft15 {
  margin-left: 15px;
}
.appendLeft16 {
  margin-left: 16px;
}
.appendLeft18 {
  margin-left: 18px;
}
.appendLeft20 {
  margin-left: 20px;
}
.appendLeft22 {
  margin-left: 22px;
}
.appendLeft24 {
  margin-left: 24px;
}
.appendLeft26 {
  margin-left: 26px;
}
.appendLeft28 {
  margin-left: 28px;
}
.appendLeft30 {
  margin-left: 30px;
}
.appendLeft32 {
  margin-left: 32px;
}
.appendLeft44 {
  margin-left: 44px;
}

/* -- FONT SIZE --*/
.font10 {
  font-size: 10px;
}
.font11 {
  font-size: 11px;
}
.font12 {
  font-size: 12px;
}
.font13 {
  font-size: 13px;
}
.font14 {
  font-size: 14px;
}
.font15 {
  font-size: 15px;
}
.font16 {
  font-size: 16px;
}
.font18 {
  font-size: 18px;
}
.font20 {
  font-size: 20px;
}
.font22 {
  font-size: 22px;
}
.font24 {
  font-size: 24px;
}
.font26 {
  font-size: 26px;
}
.font28 {
  font-size: 28px;
}
.font30 {
  font-size: 30px;
}
.font32 {
  font-size: 32px;
}

/* -- LINE HEIGHT -- */
.lineHeight10 {
  line-height: 10px !important;
}
.lineHeight14 {
  line-height: 14px !important;
}
.lineHeight16 {
  line-height: 16px !important;
}
.lineHeight20 {
  line-height: 20px !important;
}
.lineHeight24 {
  line-height: 24px !important;
}
.lineHeight28 {
  line-height: 28px !important;
}
.lineHeight32 {
  line-height: 32px !important;
}
.lineHeight48 {
  line-height: 48px !important;
}


/* -- FONT WEIGHT -- */
.latoLight {
  font-weight: 300;
}
.latoRegular {
  font-weight: 400;
}
.latoBold {
  font-weight: 700;
}
.latoBlack {
  font-weight: 900;
}

/* -- TEXT ALIGN -- */
.textLeft {
  text-align: left;
}
.textRight {
  text-align: right;
}
.textCenter {
  text-align: center;
}

/* -- HEIGHT -- */
.height46 {
  height: 46px;
}

/* -- FLEX -- */
.makeFlex {
  display: flex;
}
.makeInlFlex {
  display: inline-flex;
}
.dirColumn {
  flex-direction: column;
}
.dirRow {
  flex-direction: row;
}
.hrtlCenter {
  justify-content: center;
}
.hrtlEnd {
  justify-content: flex-end;
}
.vrtlStart {
  align-items: flex-start;
}
.vrtlCenter {
  align-items: center;
}
.perfectCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.spaceBetween {
  justify-content: space-between;
}
.hrtlBaseline {
  align-items: baseline;
}
.vrtlEnd {
  align-items: flex-end;
}
.flexOne {
  flex: 1;
}
.flexWrap {
  flex-wrap: wrap;
}
.flexShrink {
  flex-shrink: 0;
}

/* -- TEXT COLOR -- */
.primaryTxtBlack {
  color: Theme.$primaryTextBlack;
}
.primaryTxtWhite {
  color: Theme.$primaryTextWhite;
}
.secondaryTxt {
  color: Theme.$secondaryText;
}
.tertiaryTxt {
  color: Theme.$tertiaryText;
}
.blueTxt {
  color: Theme.$blueText;
}
.orangeTxt {
  color: Theme.$orangeText;
}
.warningTxt {
  color: Theme.$warningText;
}
.brownText {
  color: Theme.$brownText;
}
.emeraldTxt {
  color: Theme.$emeraldText;
}
.turqoiseTxt {
  color: Theme.$turqoiseText;
}
.purpleTxt {
  color: Theme.$purpleText;
}
.lightPurpleText{
  color: Theme.$lightPurpleText;
}
.darkPurpleTxt {
  color: Theme.$darkPurpleText;
}
.darkGreenTxt {
  /* color: Theme.$darkGreenBg; */
  color: #007E7D;
}
.goldenTxt {
  color: Theme.$goldenText;
}
.goldenTwoTxt {
  color: Theme.$goldenTextTwo;
}
.darkGoldenTxt {
  color: Theme.$darkGoldenText;
}
.darkYellowTxt {
  color: Theme.$darkYellowBg;
}
.redTxt {
  color: Theme.$redText;
}
.greenText{
  color: Theme.$emeraldText;
}

/* -- CSS SHAPES -- */
// ARROWS
.arrowLogoIcon {
  display: inline-block;
  position: relative;
  width: 15px;
  height: 12px;
}

.arrowLogoIcon::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 15px;
  height: 2px;
  transform: translate(-50%, -50%);
}

.arrowLogoIcon::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 0px;
  width: 7px;
  height: 7px;
  transform: translateY(-50%) rotate(45deg);
}

.arrowLogoIcon.white::before {
  background-color: white;
}

.arrowLogoIcon.white::after {
  border-top: 2px #ffffff solid;
  border-right: 2px #ffffff solid;
}


.arrowLogoIcon.black::before {
  background-color: black;
}

.arrowLogoIcon.black::after {
  border-top: 2px black solid;
  border-right: 2px black solid;
}

.arrowLogoIcon.grey::before {
  background-color: Theme.$tertiaryText;
}

.arrowLogoIcon.grey::after {
  border-top: 2px Theme.$tertiaryText solid;
  border-right: 2px Theme.$tertiaryText solid;
}

.miniArrowLogoIcon {
  display: inline-block;
  position: relative;
  width: 10px;
  height: 8px;
}

.miniArrowLogoIcon::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 1px;
  transform: translate(-50%, -50%);
}

.miniArrowLogoIcon::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 0px;
  width: 4px;
  height: 4px;
  transform: translateY(-50%) rotate(45deg);
}

.miniArrowLogoIcon.white::before {
  background-color: white;
}

.miniArrowLogoIcon.white::after {
  border-right: 1px #ffffff solid;
  border-top: 1px #ffffff solid;
}

.miniArrowLogoIcon.black::before {
  background-color: black;
}

.miniArrowLogoIcon.black::after {
  border-right: 1px black solid;
  border-top: 1px black solid;
}

.miniArrowLogoIcon.up {
  transform: rotate(-90deg);
}

.miniArrowLogoIcon.down {
  transform: rotate(90deg);
}

// CHEVRONS
.miniChevronIcon {
  display: inline-block;
  width: 7px;
  height: 7px;
}

.chevronIcon {
  cursor: pointer;
  display: inline-block;
  width: 9px;
  height: 9px;
  border-top: 2px white solid;
  border-right: 2px white solid;
}

.miniChevronIcon.themeIcon,
.chevronIcon.themeIcon {
  border-top: 2px Theme.$primaryColor solid;
  border-right: 2px Theme.$primaryColor solid;
}

.miniChevronIcon.linkIcon,
.chevronIcon.linkIcon {
  border-top: 2px Theme.$blueText solid;
  border-right: 2px Theme.$blueText solid;
}

.miniChevronIcon.disabledIcon,
.chevronIcon.disabledIcon {
  border-top: 2px Theme.$tertiaryText solid;
  border-right: 2px Theme.$tertiaryText solid;
}

.miniChevronIcon.tertiaryIcon,
.chevronIcon.tertiaryIcon {
  border-top: 2px Theme.$tertiaryText solid;
  border-right: 2px Theme.$tertiaryText solid;
}

.miniChevronIcon.blackIcon,
.chevronIcon.blackIcon {
  border-top: 2px Theme.$primaryTextBlack solid;
  border-right: 2px Theme.$primaryTextBlack solid;
}

.miniChevronIcon.Right,
.chevronIcon.Right {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.miniChevronIcon.Left,
.chevronIcon.Left {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.miniChevronIcon.down,
.chevronIcon.down {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.miniChevronIcon.up,
.chevronIcon.up {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.miniChevronIcon.animIcon,
.chevronIcon.animIcon {
  transition: all 0.3s linear;
}

//TICK, CROSS AND ELLIPSIS POINTS
.tickIcon,
.ellipsisIcon,
.crossIcon,
.lgCrossIcon {
  position: relative;
}

.ellipsisIcon.white,
.crossIcon.white,
.lgCrossIcon.white {
  color: white;
}

.ellipsisIcon.black,
.crossIcon.black,
.lgCrossIcon.black {
  color: black;
}

.ellipsisIcon.primaryColor,
.crossIcon.primaryColor,
.lgCrossIcon.primaryColor {
  color: Theme.$primaryColor;
}

.lgCrossIcon.greyIcon {
  color: #979797;
}

.tickIcon.small::before {
  position: absolute;
  content: '';
  top: 0px;
  left: 50%;
  height: 3px;
  width: 7px;
  border: 1px solid;
  border-right: transparent;
  border-top: transparent;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.tickIcon.large::before {
  position: absolute;
  content: '';
  top: 0px;
  left: 50%;
  height: 8px;
  width: 16px;
  border: 2px solid;
  border-right: transparent;
  border-top: transparent;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.tickIcon.white::before {
  border-color: #fff;
}

.tickIcon.black::before {
  border-color: #000;
}

.tickIcon.primaryColor::before {
  border-color: Theme.$primaryColor;
}

.ellipsisIcon.small::before {
  position: absolute;
  content: '...';
  top: 0px;
  left: 50%;
  font-size: 14px;
  transform: translate(-50%, -74%);
}

.crossIcon.small::before {
  position: absolute;
  content: '+';
  top: 0px;
  left: 50%;
  font-size: 13px;
  transform: translate(-50%, -50%) rotate(45deg) scaleX(-1);
}

.lgCrossIcon::before {
  position: absolute;
  content: '+';
  top: 0px;
  left: 50%;
  font-weight: 300;
  font-size: 35px;
  transform: translate(-50%, -50%) rotate(45deg) scaleX(-1);
}

//TICKS WITH ROUND WITH BG
@mixin tickPseudoStyles {
  content: 'L';
  position: absolute;
  color: white;
  top: 50%;
  left: 50%;
  transform: translate(-45%, -55%) scaleX(-1) rotate(-45deg);
}

// COLOR VARIATIONS
@mixin greenTickStyles {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 50%;
  background: #26b5a9;
}

.greenTick {
  @include greenTickStyles;
  height: 20px;
  width: 20px;
}

.greenTick::before {
  @include tickPseudoStyles;
  font-size: 13px;
  font-weight: 700;
}

@mixin yellowTickStyles {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 50%;
  background: #de8a00;
}

.yellowTick {
  @include yellowTickStyles;
  height: 20px;
  width: 20px;
}

.yellowTick::before {
  @include tickPseudoStyles;
  font-size: 13px;
  font-weight: 700;
}

.miniGreenTick {
  @include greenTickStyles;
  height: 13px;
  width: 13px;
}

.miniGreenTick::before {
  @include tickPseudoStyles;
  font-size: 9px;
}

//  CROSS ICONS 

.addModal_close{
  width: 20px;
  height: 20px;
  position: relative;
  margin-left: auto;
  cursor: pointer;
}
.addModal_close::after{
  position: absolute;
  left: 7px;
  content: " ";
  height: 20px;
  width: 2px;
  background-color: #757575;
  transform: rotate(-45deg);
}
.addModal_close::before{
  position: absolute;
  left: 7px;
  content: " ";
  height: 20px;
  width: 2px;
  background-color: #757575;
  transform: rotate(45deg);
}

// ROUND CROSS ICONS
@mixin roundDelIconBaseStyles {
  display: inline-block;
  position: relative;
  border-radius: 50%;
}

.miniRoundDelIcon {
  @include roundDelIconBaseStyles;
  width: 13px;
  height: 13px;
}

.roundDelIcon {
  @include roundDelIconBaseStyles();
  width: 18px;
  height: 18px;
}

.medRoundDelIcon {
  @include roundDelIconBaseStyles();
  width: 20px;
  height: 20px;
}

.lgRoundDelIcon {
  @include roundDelIconBaseStyles;
  width: 24px;
  height: 24px;
}

@mixin miniRoundDelIconStyles {
  content: '';
  position: absolute;
  width: 8px;
  height: 1px;
  top: 50%;
  left: 50%;
  background-color: #ffffff;
}

.miniRoundDelIcon::before {
  @include miniRoundDelIconStyles;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.miniRoundDelIcon::after {
  @include miniRoundDelIconStyles;
  transform: translate(-50%, -50%) rotate(45deg);
}

@mixin roundDelIconStyles {
  content: '';
  position: absolute;
  width: 10px;
  height: 1px;
  top: 50%;
  left: 50%;
  background-color: #ffffff;
}

.roundDelIcon::before {
  @include roundDelIconStyles;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.roundDelIcon::after {
  @include roundDelIconStyles;
  transform: translate(-50%, -50%) rotate(45deg);
}

@mixin medRoundDelIconStyles {
  content: '';
  position: absolute;
  width: 12px;
  height: 1px;
  top: 50%;
  left: 50%;
  background-color: #ffffff;
}

.medRoundDelIcon::before {
  @include medRoundDelIconStyles;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.medRoundDelIcon::after {
  @include medRoundDelIconStyles;
  transform: translate(-50%, -50%) rotate(45deg);
}

@mixin lgRoundDelIconStyles {
  content: '';
  position: absolute;
  width: 14px;
  height: 2px;
  top: 50%;
  left: 50%;
  background-color: #ffffff;
}

.lgRoundDelIcon::before {
  @include lgRoundDelIconStyles;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.lgRoundDelIcon::after {
  @include lgRoundDelIconStyles;
  transform: translate(-50%, -50%) rotate(45deg);
}

.miniRoundDelIcon.tertiaryBg,
.roundDelIcon.tertiaryBg,
.medRoundDelIcon.tertiaryBg,
.lgRoundDelIcon.tertiaryBg {
  background-color: Theme.$tertiaryText;
}

.miniRoundDelIcon.redBg,
.roundDelIcon.redBg,
.medRoundDelIcon.redBg,
.lgRoundDelIcon.redBg {
  background-color: Theme.$redBg;
}

.miniRoundDelIcon.themeBg,
.roundDelIcon.themeBg,
.medRoundDelIcon.themeBg,
.lgRoundDelIcon.themeBg {
  background-color: Theme.$primaryColor;
}

.miniRoundDelIcon.secondaryBg,
.roundDelIcon.secondaryBg,
.medRoundDelIcon.secondaryBg,
.lgRoundDelIcon.secondaryBg {
  background-color: Theme.$secondaryText;
}

// GREEN GRADIENT NEW TAG
.newTagIcon {
  padding: 2px 8px;
  color: #fff;
  width: max-content;
  font-size: 10px;
  line-height: 10px;
  display: inline-block;
  font-weight: 700;
  border-radius: 10px;
  background: linear-gradient(45deg, #43e1a8 0%, #219393 100%);
}

.newTagIcon.redBg {
  background: #D84E55;
}

.newDotIcon {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  display: inline-block;
  background: linear-gradient(45deg, #43e1a8 0%, #219393 100%);
}

.newDotIcon.golden {
  background: Theme.$darkYellowBg;
}

.redDotMinusIcon {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: Theme.$redBg;
}

.redDotMinusIcon::before {
  content: '';
  position: absolute;
  width: 50%;
  height: 2px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
}

.newTagIcon.smallIcon {
  padding: 2px 4px;
}

// CLOCK ICON
.roundClockIcon {
  display: inline-block;
  position: relative;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px #000 solid;
}

@mixin clockIconStyles {
  position: absolute;
  content: '';
  width: 40%;
  height: 1px;
  top: 50%;
  left: 50%;
  background-color: black;
}

.roundClockIcon::before {
  @include clockIconStyles;
  transform: translate(-0.5px, -50%);
}

.roundClockIcon::after {
  @include clockIconStyles;
  transform: translate(-50%, calc(-100% - 1.5px)) rotate(90deg);
}

// COLOR VARIATIONS
.roundClockIcon.whiteLines {
  border: 1px white solid;
}

.roundClockIcon.whiteLines::before,
.roundClockIcon.whiteLines::after {
  background-color: white;
}

// TICK WITH GREEN BG
.successGreenIcon {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(45deg, #43e1a8 0%, #219393 100%);
}

.successGreenIcon::before {
  content: '';
  position: absolute;
  top: 9px;
  left: 6px;
  width: 2px;
  height: 5px;
  transform: rotate(-45deg);
  background-color: white;
  border-radius: 1px 1px 0 0;
}

.successGreenIcon::after {
  content: '';
  position: absolute;
  top: 5px;
  left: 10px;
  width: 2px;
  height: 9px;
  transform: rotate(45deg);
  background-color: white;
  border-radius: 1px 1px 0 0;
}

.successGreenIcon.greenBg {
  background: Theme.$lightGreenBg;
}

// WARNING WITH GOLDEN BG
.warningIcon {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background: linear-gradient(226.97deg, #dc8c52 13.71%, #d8b025 86.29%);
}

.warningIcon::before {
  position: absolute;
  content: '!';
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-weight: 900;
  font-size: 14px;
}

// DOT MARK
@mixin dotMarkStyles {
  display: inline-block;
  border-radius: 50%;
}

.dotMark {
  @include dotMarkStyles;
  height: 6px;
  width: 6px;
  background-color: Theme.$secondaryText;
}

.dotMark.blackIcon {
  background-color: #000;
}

.dotMark.orangeIcon {
  background-color: Theme.$orangeBg;
}

.dotMark.redIcon {
  background-color: Theme.$redBg;
}
.dotMark.darkGreenIcon{
  background-color: #1a7971;
}

.dotMarkSmall {
  @include dotMarkStyles;
  height: 2px;
  width: 2px;
  background-color: Theme.$secondaryText;
}

.dotMarkSmall.blackIcon {
  background-color: #000;
}

.dotMarkSmall.orangeIcon {
  background-color: Theme.$orangeText;
}

.dotMarkSmall.redIcon {
  background-color: Theme.$redBg;
}

.dotMarkLarge {
  @include dotMarkStyles;
  height: 8px;
  width: 8px;
  background-color: Theme.$secondaryText;
}

.dotMarkLarge.blackIcon {
  background-color: #000;
}

.dotMarkLarge.orangeIcon {
  background-color: Theme.$orangeText;
}

.dotMarkLarge.redIcon {
  background-color: Theme.$redBg;
}
.dotMarkLarge.darkGreenIcon{
  background-color: #1a7971;
}

// TICK MARK
.tickMark {
  display: inline-block;
  width: 12px;
  height: 6px;
  transform: rotate(-45deg);
  border-left: 2px solid Theme.$darkGreenBg;
  border-bottom: 2px solid Theme.$darkGreenBg;
}

.actionArrow {
  position: relative;
  display: inline-block;
  width: 24px;
  height: 18px;
}

.actionArrow::after {
  content: '';
  position: absolute;
  top: 8px;
  left: 0px;
  width: 24px;
  height: 2px;
  border-radius: 1px;
  background: Theme.$MYP_PRIMARY_COLOR;
}

.actionArrow::before {
  content: '';
  position: absolute;
  top: 6px;
  left: 18px;
  width: 6px;
  height: 6px;
  transform: rotate(45deg);
  border: solid 2px Theme.$MYP_PRIMARY_COLOR;
  border-left: none;
  border-bottom: none;
}

.actionArrow.white::after {
  background: #fff;
}

.actionArrow.white::before {
  border: 2px #fff solid;
  border-left: none;
  border-bottom: none;
}

.arrow {
  border: solid #008cff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
}

.arrow.dwn {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.arrow.rgt {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

// FROM TO JOURNEY LOGO
// LANDING VERSION
.fromTojourneyLogo {
  display: inline-block;
  position: relative;
  width: 16px;
  height: 8px;
  border-top: 2px Theme.$primaryColor solid;
  border-bottom: 2px Theme.$primaryColor solid;
}

.fromTojourneyLogo::before {
  content: '';
  position: absolute;
  top: -4.5px;
  right: 0px;
  width: 6px;
  height: 2px;
  transform: rotate(45deg);
  background-color: Theme.$primaryColor;
}

.fromTojourneyLogo::after {
  content: '';
  position: absolute;
  top: 6.5px;
  left: 0px;
  width: 6px;
  height: 2px;
  transform: rotate(45deg);
  background-color: Theme.$primaryColor;
}

// MODIFY SEARCH VERSION
.fromTojourneyLogo.small {
  display: inline-block;
  position: relative;
  width: 12px;
  height: 6px;
  border-top: 2px Theme.$primaryColor solid;
  border-bottom: 2px Theme.$primaryColor solid;
}

.fromTojourneyLogo.small::before {
  content: '';
  position: absolute;
  top: -4px;
  right: 0px;
  width: 5px;
  height: 2px;
  transform: rotate(45deg);
  background-color: Theme.$primaryColor;
}

.fromTojourneyLogo.small::after {
  content: '';
  position: absolute;
  top: 4px;
  left: 0px;
  width: 5px;
  height: 2px;
  transform: rotate(45deg);
  background-color: Theme.$primaryColor;
}
  `,
);
